angular
  .module('contributor')

  .factory('RatingVoiceCrud', [
    'Crud',

    function(Crud) {
      'use strict';

      class RatingVoiceCrud extends Crud {
        constructor(list) {
          super(
            'rating_voice' + (list || ''),
            '@@apiUrl' + '/ratings' + (list || '') + '/:id',
            { id: '@id' },
            {
              query: {
                method: 'GET',
                isArray: true
              }
            }
          );
        }
      }

      return RatingVoiceCrud;
    }
  ]);
